import { useTranslation } from "react-i18next";
import FooterPageBoilerplate from "./FooterPageBoilerplate";

export default function TermsAndCondition() {
  const { t } = useTranslation();

  return (
    <FooterPageBoilerplate title={t("termsAndConditionsTitle")}>
      {t("termsAndConditionsDescription")}
    </FooterPageBoilerplate>
  );
}
